import api from './index';

export async function getGardenData(user_id) {
  const res = await api.post('/gardens/fetchGardens', { user_id });
  return res.data;
}
